import { getAuth, multiFactor } from "firebase/auth";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { useAuthStore } from "@/auth/stores/auth";

const EXEMPT_ROUTE_NAMES = new Set([
  "login",
  "register",
  "invite",
  "resetpassword",
  "resetPassword",
  "mfaSetup",
]);

/**
 * Hard 2FA gate: if any account the user belongs to requires 2FA and the
 * signed-in Firebase user has no enrolled factor, block navigation and send
 * them to the mandatory enrollment screen. Re-checked on every navigation so
 * open sessions are caught after an owner enables the requirement.
 */
export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  if (to.matched.some((record) => record.meta.skipMerchantGuards)) {
    next();
    return;
  }

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (!requiresAuth || EXEMPT_ROUTE_NAMES.has(String(to.name))) {
    next();
    return;
  }

  const { currentUser } = getAuth();
  if (!currentUser || !currentUser.emailVerified) {
    next();
    return;
  }

  const authStore = useAuthStore();
  if (authStore.anyAccountRequires2fa && multiFactor(currentUser).enrolledFactors.length === 0) {
    next({ name: "mfaSetup" });
    return;
  }

  next();
};
